import { type FC, useEffect, useRef } from 'react';
import { useCountUp } from 'react-countup';

import { toShortNumFormat } from '@/common/lib/toShortNumFormat';

const CounterUpDown: FC<{
  value: number;
  delay: number;
  duration: number;
  className?: string;
}> = ({ value, delay, duration, className }) => {
  const countUpRef = useRef(null);

  const { update, getCountUp } = useCountUp({
    ref: countUpRef,
    start: value,
    end: value,
    delay: 0,
    duration,
    startOnMount: false,
    formattingFn: (value) => toShortNumFormat(value ?? 0),
  });

  useEffect(() => {
    if (!getCountUp().el.innerHTML) {
      update(value || 0);

      return;
    }

    const timerId = setTimeout(() => {
      update(value || 0);
      clearTimeout(timerId);
    }, delay);

    return (): void => {
      clearTimeout(timerId);
    };
  }, [value, delay]);

  return <span className={className} ref={countUpRef} />;
};

export { CounterUpDown };
